import { useMiddleFeaturesContext } from '@@app/hooks';

export const withMiddleFeatures = (Component) => {
  return function withMiddleFeatures (props) {
    const { middleFeatures, getMiddleText, getMiddleImageSrc, getMiddleNumber, getMiddleBoolean } =
      useMiddleFeaturesContext();

    return (
      <Component
        {...props}
        middleFeatures={middleFeatures}
        getMiddleText={(textId, variables, defaultValue = textId) =>
          getMiddleText(middleFeatures, textId, variables, defaultValue)
        }
        getMiddleImageSrc={(imageId, params, defaultValue) =>
          getMiddleImageSrc(middleFeatures, imageId, params, defaultValue)
        }
        getMiddleNumber={(numberId, defaultValue) =>
          getMiddleNumber(middleFeatures, numberId, defaultValue)
        }
        getMiddleBoolean={(booleanId, defaultValue) =>
          getMiddleBoolean(middleFeatures, booleanId, defaultValue)
        }
      />
    );
  };
};

export default withMiddleFeatures;
